import * as React from 'react';
import {TypeImplementation, withSystem} from '@packages/systems/wfdl';
import {ERecord, EText, EUnion, TText} from '@packages/systems/wfdl-ast';
import {TOption} from '@packages/systems/plugins/Option';
import {
  ExpressionEditor,
  updateExpressionAction,
} from '@packages/systems/ExpressionEditor-utils';
import TextInput from '@packages/systems/design-system/TextInput';
import {
  ContextualExpression,
  ContextualExpressions,
  stripAnn,
} from '@packages/utilities/contextual-expression';

const underlyingType = TOption(TText);

function makeRender(
  getValue: (expr: ContextualExpression) => null | string,
  getAction: (val: string) => TypeImplementation.ExpressionEditorAction
) {
  return function DataType({
    expr,
    dispatch,
  }: {
    expr: ContextualExpression;
    dispatch: TypeImplementation.ExpressionEditorDispatch;
  }) {
    const dispatchRef = React.useRef(dispatch);
    dispatchRef.current = dispatch;
    const val = getValue(expr);
    const [value, setValue] = React.useState(val);

    // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    const onChange = React.useCallback((e) => {
      const inputVal = e.target.value;
      setValue(inputVal);
      const action = getAction(inputVal);
      if (action) dispatchRef.current(action);
    }, []);

    const onBlur = React.useCallback(
      // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
      (e) => {
        const inputVal = e.currentTarget.value;
        const action = getAction(inputVal);
        if (action) {
          setValue(inputVal);
          dispatchRef.current(action);
        } else {
          setValue(val);
        }
      },
      [val]
    );

    return (
      <>
        <TextInput
          onChange={onChange}
          onBlur={onBlur}
          value={value || ''}
          placeholder="Enter text..."
        />
      </>
    );
  };
}

const OptionInput = makeRender(
  (expr) => {
    const union = ContextualExpressions.getUnion(stripAnn(expr));
    return union && union.tag === 'Some'
      ? ContextualExpressions.getText(stripAnn(union.value))
      : '';
  },
  (newVal) => {
    if (newVal === '') {
      return updateExpressionAction(
        EUnion({
          tag: 'None',
          value: ERecord({}),
        })
      );
    }
    return updateExpressionAction(EUnion({tag: 'Some', value: EText(newVal)}));
  }
);
export const OptionalText = TypeImplementation.Alias({
  type: withSystem({labelVariant: 'hidden'}, underlyingType),
  render: ({expr, dispatch}) =>
    ContextualExpressions.isBinding(stripAnn(expr)) ? (
      <ExpressionEditor expression={expr} dispatch={dispatch} />
    ) : (
      <OptionInput expr={expr} dispatch={dispatch} />
    ),
});
